import { LitElement, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { enumAttributeConverter, Sizes, States, Variant } from '../enum-types.ts';
import { AtlStatusChipProps, StatusVariant } from './chip.props.ts';

import * as TagNames from './chip.tagnames.ts';

const statusVariantsLabelMap = {
    [StatusVariant.Overdue]: StatusVariant.Overdue,
    [StatusVariant.DueBy]: "Due By",
    [StatusVariant.Done]: StatusVariant.Done,
    [StatusVariant.Skipped]: StatusVariant.Skipped,
    [StatusVariant.InProgress]: "In Progress",
}

const statusVariantsToVariantMap = {
    [StatusVariant.Overdue]: Variant.DangerBordered,
    [StatusVariant.DueBy]: Variant.WarningBordered,
    [StatusVariant.Done]: Variant.SuccessBordered,
    [StatusVariant.Skipped]: Variant.SecondaryBordered,
    [StatusVariant.InProgress]: Variant.PrimaryBordered,
};

const avatarIconsMap = {
    [StatusVariant.Overdue]: "circle-exclamation",
    [StatusVariant.DueBy]: "clock",
    [StatusVariant.Done]: "circle-check",
    [StatusVariant.Skipped]: "ban",
    [StatusVariant.InProgress]: "spinner"
};

@customElement(TagNames.StatusChip)
export class AtlStatusChip extends LitElement implements AtlStatusChipProps {
    declare label?: string;
    declare variant: StatusVariant;
    declare reverseOrder?: boolean;
    declare size?: Sizes;
    declare state?: States;
    declare avatarIconName?: string;
    declare showAvatarIcon?: boolean;
    declare hiddenLabel?: string;
    declare iconName?: string;
    declare iconClassName?: string;
    declare clickable?: boolean;
    declare deletable?: boolean;

    static properties = {
        label: { type: String },
        variant: { type: String, converter: enumAttributeConverter(StatusVariant, StatusVariant.Overdue) },
        reverseOrder: { attribute: 'reverse-order', type: Boolean },
        size: { type: String, converter: enumAttributeConverter(Sizes, Sizes.Medium) },
        state: { type: String, converter: enumAttributeConverter(States, States.Normal) },
        avatarIconName: { attribute: 'avatar-icon-name', type: String },
        showAvatarIcon: { attribute: 'show-avatar-icon', type: Boolean },        
        hiddenLabel: { attribute: 'hidden-label', type: Boolean },
        iconName: { attribute: 'icon-name', type: String },
        iconClassName: { attribute: 'icon-class-name', type: String },
        clickable: { type: Boolean },
        deletable: { type: Boolean }
    };

    render() {
        let iconToUse: string | undefined = undefined;
        if (this.showAvatarIcon) {
            iconToUse = this.avatarIconName || avatarIconsMap[this.variant];
        }
        return html`<atlantis-chip 
            label=${this.label || statusVariantsLabelMap[this.variant]}
            variant=${statusVariantsToVariantMap[this.variant]}
            reverse-order=${this.reverseOrder || nothing}
            size=${this.size || nothing}
            state=${this.state || nothing}
            avatar-icon-name=${iconToUse || nothing}
            icon-name=${this.iconName || nothing}
            icon-class-name=${this.iconClassName || nothing}
            hidden-label=${this.hiddenLabel || nothing}
            ?deletable=${this.deletable}
            ?clickable=${this.clickable}
            >
            </atlantis-chip>`;
    }
}